// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CourseForm from "./CourseForm";

function Course() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;
  const isDuplicated = router.pathname.includes("duplicate");

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "courses/private/data",
    id
  );

  if (isDuplicated && item) {
    delete item.status;
  }

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/courses");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataCourse: any) => {
      const newCourse = { ...dataCourse };

      if (isDuplicated) {
        delete newCourse.id;
      }

      try {
        if (newCourse.id) {
          await updateItem(newCourse.id, newCourse);
        } else {
          await saveItem(newCourse);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [isDuplicated, back, updateItem, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <CourseForm onSubmit={onSubmit} course={item} isFetching={isFetching} />
  );
}

export default Course;
